import React, { useMemo } from 'react'
import {DateTime} from 'luxon';
import { OrderSummary } from 'app/booking'

import styles from './Order.module.scss'

export default ({ status, order }) => {
  const events = useMemo(() => {
    const events = [];

    const confirmedDate = DateTime.fromISO(order.info.confirmedDate);
    events.push({
      utc: order.info.confirmedDate,
      component: (
        <div className={styles.event} data-type="confirmed">
          Confirmed on <strong>{
            confirmedDate.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)
          }</strong> at <strong>{
            confirmedDate.toLocaleString(DateTime.TIME_SIMPLE)
          }</strong> by <strong>{order.info.confirmedUser}</strong>.
        </div>
      )
    });

    if (order.info.cancelledDate) {
      const cancelledDate = DateTime.fromISO(order.info.cancelledDate);
      events.push({
        utc: order.info.cancelledDate,
        component: (
          <div className={styles.event} data-type="cancelled">
            Cancelled on <strong>{
              cancelledDate.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)
            }</strong> at <strong>{
              cancelledDate.toLocaleString(DateTime.TIME_SIMPLE)
            }</strong> by <strong>{
              order.info.cancelledUser
            }</strong>.
          </div>
        )
      });
    }
    else if (order.info.deliveredDate) {
      const deliveredDate = DateTime.fromISO(order.info.deliveredDate);
      events.push({
        utc: order.info.deliveredDate,
        component: (
          <div className={styles.event} data-type="delivered">
            Delivered on <strong>{
              deliveredDate.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)
            }</strong> at <strong>{
              deliveredDate.toLocaleString(DateTime.TIME_SIMPLE)
            }</strong>.
          </div>
        )
      });
    }
    else {
      const deliveryDate = DateTime.fromISO(order.schedule.deliveryDeadline);
      events.push({
        utc: order.schedule.deliveryDeadline,
        component: (
          <div className={styles.event} data-type="delivery">
            Scheduled delivery on <strong>{deliveryDate.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)}</strong>.
          </div>
        )
      });
    }

    return events.sort((a, b) => a.utc === b.utc ? 0 : a.utc > b.utc ? 1 : -1);
  }, [order]);

  return (
    <div className={styles.order}>
      <div className={styles.events} data-status={status}>
        { events.map((t, i) => (
          <React.Fragment key={i}>{t.component}</React.Fragment>
        ))}
      </div>
      <div className={styles.summary}>
        <div className={styles.title}>Order summary</div>
        <OrderSummary order={order} />
      </div>
    </div>
  )
}
